import React, { useRef, useState, useContext } from 'react';
import Truncate from 'react-truncate';
import { Link, useParams } from 'react-router-dom';

import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Avatar from '@material-ui/core/Avatar';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import SettingsIcon from '@material-ui/icons/Settings';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { APP_ENDPOINT } from 'config';
import { getDisplayName, getTeamLink } from 'utils/misc';
import { getRole, checkPermission } from 'roles/checkPermission';
import AppContext from 'AppContext';

export default function Profile({ profile, teamId }) {
  const { picture, email } = profile || {};
  const [open, setOpen] = useState(false);
  const panelEl = useRef(null);
  const { teamId: teamIdFromUrl } = useParams();
  const { orgs, userMeta } = useContext(AppContext);

  const displayName = getDisplayName(profile);
  const currentTeamId = teamIdFromUrl || teamId;
  const currentOrgId = orgs.find((org) => org.teams.includes(currentTeamId))?.id;

  // Check user permissions
  const { role } = getRole({ orgId: currentOrgId, teamId: currentTeamId, userMeta });
  const canEditTeam = checkPermission(role, 'team:edit');
  const canEditMembers = checkPermission(role, 'member:edit');

  const handleOpen = (e) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (!profile) {
    return null;
  }

  return (
    <div className="profile" onMouseOver={handleOpen} onMouseLeave={handleClose}>
      <Avatar ref={panelEl} className="profileImg" alt={displayName} src={picture} />
      <div className="actionPanelList">
        {/** Important: this popper has no disablePortal, as it causing overflow in safari **/}
        <Popper style={{ zIndex: 1 }} anchorEl={panelEl.current} open={open} placement="bottom" transition>
          {({ TransitionProps, placement }) => (
            <Grow {...TransitionProps} style={{ transformOrigin: 'center top' }}>
              <Paper>
                <div className="actionPanelBoard actionPanelBoard-profile">
                  <h3 onMouseOver={handleOpen}>
                    <Truncate width={300}>{displayName === email ? 'Profile' : displayName}</Truncate>
                  </h3>
                  <p>
                    <Truncate width={300}>{email}</Truncate>
                  </p>
                  <section className="menu-section">
                    <Link to={'/'} className="menu-item" onClick={handleClose}>
                      <EqualizerIcon style={{ fontSize: '18px', marginRight: '8px' }} />
                      <span>Dashboard</span>
                    </Link>
                    {currentTeamId && canEditMembers && (
                      <Link
                        to={getTeamLink({ teamId: currentTeamId, menu: 'members' })}
                        className="menu-item"
                        onClick={handleClose}
                      >
                        <PersonAddIcon style={{ fontSize: '18px', marginRight: '8px' }} />
                        <span>Invite Members</span>
                      </Link>
                    )}
                    {currentTeamId && canEditTeam && (
                      <Link
                        to={getTeamLink({ teamId: currentTeamId, menu: 'settings' })}
                        className="menu-item"
                        onClick={handleClose}
                      >
                        <SettingsIcon style={{ fontSize: '18px', marginRight: '8px' }} />
                        <span>Team Settings</span>
                      </Link>
                    )}
                  </section>
                  <section className="menu-section">
                    <a href={`${APP_ENDPOINT}/logout`} className="menu-item">
                      <ExitToAppIcon style={{ fontSize: '18px', marginRight: '8px' }} />
                      <span>Sign out</span>
                    </a>
                  </section>
                </div>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
}
